// auth
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const LOGOUT_USER = 'LOGOUT_USER'

export const UPDATE_USER_JWT = 'UPDATE_USER_JWT'
export const UPDATE_USER = 'UPDATE_USER'

export const UPDATE_ISP = 'UPDATE_ISP'
export const CLEAR_ISP = 'CLEAR_ISP'

export const APP_STATE = 'APP_STATE'